export default "__VITE_ASSET__59a376dd__"